<script>
// import Constants from '../constants';

export default {
  name: 'moveTextHover',
  components: {
  },
  props: {
    targetText: {
      type: String,
      required: true,
    },
    isHoverMove: {
      type: Boolean,
      default: true,
    },
    isRandomMove: {
      type: Boolean,
      default: true,
    },
    randomMovePercentage: {
      type: Number,
      default: 0.1,
    },
    isPointer: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      texts: [],
    };
  },
  created() {
    this.texts =  this.targetText.split('');
  },
  methods: {
    isRandom() {
      return Math.random() <= this.randomMovePercentage;
    },
  },
};
</script>

<template>
  <span class="move-text-hover" :class="[
    isHoverMove ? 'is-hoverMove' : '',
    isRandomMove ? 'is-randomMove' : '',
    isPointer ? 'is-pointer' : '',
  ]">
    <span v-for="(t, i) in texts" :key="i" :class="isRandom() ? 'randomMove' : ''">{{t}}</span>
  </span>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .move-text-hover {
    &.is-pointer {
      cursor: pointer;
    }
    position: relative;
    span {
      position: relative;
      display: inline-block;
      min-width: 5px;
    }
    &.is-randomMove {
      .randomMove {
        animation: animeRandom 20s ease 0s infinite;
      }
      span:nth-child(10n-9).randomMove{animation-delay: 2s;}
      span:nth-child(10n-8).randomMove{animation-delay: 12s;}
      span:nth-child(10n-7).randomMove{animation-delay: 0s;}
      span:nth-child(10n-6).randomMove{animation-delay: 16s;}
      span:nth-child(10n-5).randomMove{animation-delay: 6s;}
      span:nth-child(10n-4).randomMove{animation-delay: 18s;}
      span:nth-child(10n-3).randomMove{animation-delay: 4s;}
      span:nth-child(10n-2).randomMove{animation-delay: 8s;}
      span:nth-child(10n-1).randomMove{animation-delay: 14s;}
      span:nth-child(10).randomMove{animation-delay: 10s;}
    }
    &.is-hoverMove {
      &:hover {
        span:nth-child(5n-4){animation: anime1 4s ease 0s infinite !important;}
        span:nth-child(5n-3){animation: anime2 4s ease 0s infinite !important;}
        span:nth-child(5n-2){animation: anime3 4s ease 0s infinite !important;}
        span:nth-child(5n-1){animation: anime4 4s ease 0s infinite !important;}
        span:nth-child(5n){animation: anime5 4s ease 0s infinite !important;}
      }
    }
  }
	
@keyframes anime1 {
	0%{top: 0px; left: 0px;}
  5%{top: -3px; left: -1px;}
  30%{top: -3px; left: -1px;}
  35%{top: 2px; left: 1px;}
  50%{top: 2px; left: 1px;}
  55%{top: -2px; left: 2px;}
  70%{top: -2px; left: 2px;}
  75%{top: 0px; left: 0px;}
  100%{top: 0px; left: 0px;}
}

@keyframes anime2 {
	0%{top: 0px; left: 0px;}
  5%{top: 2px; left: 0px;}
  30%{top: 2px; left: 0px;}
  35%{top: -2px; left: 1px;}
  50%{top: -2px; left: 1px;}
  55%{top: 1px; left: -2px;}
  70%{top: 1px; left: -2px;}
  75%{top: 0px; left: 0px;}
  100%{top: 0px; left: 0px;}
}

@keyframes anime3 {
	0%{top: 0px; left: 0px;}
  5%{top: -2px; left: 1px;}
  30%{top: -2px; left: 1px;}
  35%{top: 0px; left: 0px;}
  50%{top: 0px; left: 0px;}
  55%{top: 3px; left: -1px;}
  70%{top: 3px; left: -1px;}
  75%{top: 0px; left: 0px;}
  100%{top: 0px; left: 0px;}
}

@keyframes anime4 {
	0%{top: 0px; left: 0px;}
  5%{top: 1px; left: 2px;}
  30%{top: 1px; left: 2px;}
  35%{top: -3px; left: 1px;}
  50%{top: -3px; left: 1px;}
  55%{top: -2px; left: 1px;}
  70%{top: -2px; left: 1px;}
  75%{top: 0px; left: 0px;}
  100%{top: 0px; left: 0px;}
}

@keyframes anime5 {
	0%{top: 0px; left: 0px;}
  5%{top: 3px; left: -1px;}
  30%{top: 3px; left: -1px;}
  35%{top: 1px; left: -1px;}
  50%{top: 1px; left: -1px;}
  55%{top: 2px; left: 1px;}
  70%{top: 2px; left: 1px;}
  75%{top: 0px; left: 0px;}
  100%{top: 0px; left: 0px;}
}

@keyframes animeRandom {
  0%{top: 0px; left: 0px;}
  20%{top: 0px; left: 0px;}
  21%{top: -3px; left: 0px;}
  22%{top: -3px; left: 0px; transform:rotateY(0deg);}
  29%{top: -3px; left: 0px; transform:rotateY(1turn);}
  30%{top: 0px; left: 0px; transform:rotateY(1turn);}
  100%{top: 0px; left: 0px; transform:rotateY(1turn);}
}
</style>
